import styled from 'styled-components/macro'
import IconCopy from '../../../assets/img/icon_copy.png'
import IconCopyHover from '../../../assets/img/icon_copy_hover.png'

const Label = styled.label`
  cursor: pointer;
  position: relative;
  span {
    color: #0485dc;
    font-weight: 500;
    font-size: 0.6rem;
    text-align: center;
    z-index: 10;
    margin-left: 12px;
    top: 0.1rem;
    left: 2rem;
  }
`

const CopyIcon = styled.img`
  content: url(${IconCopy});
  margin-left: 0.6rem;
  vertical-align: middle;
  &:hover {
    content: url(${IconCopyHover});
    margin-left: 0.6rem;
    vertical-align: middle;
  }
`

const CopyText = styled.textarea`
  width: 0;
  height: 0;
  opacity: 0;
`

export { Label, CopyIcon, CopyText }
